import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { AuthorizationQuestionnaireItem } from './questionnaire'

// Authorization section questionnaire answer type mapping
export const AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [AuthorizationQuestionnaireItem.AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [AuthorizationQuestionnaireItem.AUTHORIZATION_AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [AuthorizationQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
    QuestionnaireAnswerType.REFERENCE
}
